"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "assisi": {
    "418cd4e2": [{
      "hkey": "518cde94",
      "slug": "armenzano",
      "name": "Armenzano",
      "primary": true,
      "skipSearch": false
    }],
    "armezzano": [{
      "hkey": "518cde94",
      "slug": "armenzano",
      "name": "Armenzano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "34c378f5": [{
      "hkey": "a6dd757c",
      "slug": "assisi",
      "name": "Assisi",
      "primary": true,
      "skipSearch": false
    }],
    "costa-di-trex": [{
      "hkey": "a6dd757c",
      "slug": "assisi",
      "name": "Assisi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f66a482d": [{
      "hkey": "a6dd757c",
      "slug": "assisi",
      "name": "Assisi",
      "primary": true,
      "skipSearch": false
    }],
    "mora": [{
      "hkey": "a6dd757c",
      "slug": "assisi",
      "name": "Assisi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "888f63f4": [{
      "hkey": "167c7ebb",
      "slug": "palazzo-tordibetto",
      "name": "Palazzo-Tordibetto",
      "primary": true,
      "skipSearch": false
    }],
    "palazzo": [{
      "hkey": "167c7ebb",
      "slug": "palazzo-tordibetto",
      "name": "Palazzo-Tordibetto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "8f274ff8": [{
      "hkey": "e7a934dd",
      "slug": "capodacqua",
      "name": "Capodacqua",
      "primary": true,
      "skipSearch": false
    }],
    "passaggio-d-assisi": [{
      "hkey": "e7a934dd",
      "slug": "capodacqua",
      "name": "Capodacqua",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "assisi"
    }],
    "1ec4f919": [{
      "hkey": "56971bf3",
      "slug": "petrignano-torchiagina",
      "name": "Petrignano-Torchiagina",
      "primary": true,
      "skipSearch": false
    }],
    "petrignano": [{
      "hkey": "56971bf3",
      "slug": "petrignano-torchiagina",
      "name": "Petrignano-Torchiagina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "27429d33": [{
      "hkey": "4597c911",
      "slug": "pian-della-pieve-ponziano-san-presto",
      "name": "Pian della Pieve-Ponziano-San Presto",
      "primary": true,
      "skipSearch": false
    }],
    "porziano": [{
      "hkey": "4597c911",
      "slug": "pian-della-pieve-ponziano-san-presto",
      "name": "Pian della Pieve-Ponziano-San Presto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "747c735d": [{
      "hkey": "0d5544bc",
      "slug": "santa-maria-degli-angeli",
      "name": "Santa Maria degli Angeli",
      "primary": true,
      "skipSearch": false
    }],
    "s-m-degli-angeli": [{
      "hkey": "0d5544bc",
      "slug": "santa-maria-degli-angeli",
      "name": "Santa Maria degli Angeli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "8df52345": [{
      "hkey": "a6dd757c",
      "slug": "assisi",
      "name": "Assisi",
      "primary": true,
      "skipSearch": false
    }],
    "s-m-di-lignano": [{
      "hkey": "a6dd757c",
      "slug": "assisi",
      "name": "Assisi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3de48de4": [{
      "hkey": "56971bf3",
      "slug": "petrignano-torchiagina",
      "name": "Petrignano-Torchiagina",
      "primary": true,
      "skipSearch": false
    }],
    "torchiagina": [{
      "hkey": "56971bf3",
      "slug": "petrignano-torchiagina",
      "name": "Petrignano-Torchiagina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "assisi"
    }],
    "3211db1f": [{
      "hkey": "167c7ebb",
      "slug": "palazzo-tordibetto",
      "name": "Palazzo-Tordibetto",
      "primary": true,
      "skipSearch": false
    }],
    "tordibetto": [{
      "hkey": "167c7ebb",
      "slug": "palazzo-tordibetto",
      "name": "Palazzo-Tordibetto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "assisi"
    }],
    "f237264a": [{
      "hkey": "235bafc9",
      "slug": "san-vitale-viole",
      "name": "San Vitale-Viole",
      "primary": true,
      "skipSearch": false
    }],
    "viole": [{
      "hkey": "235bafc9",
      "slug": "san-vitale-viole",
      "name": "San Vitale-Viole",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;